var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal modal_size", attrs: { id: "modal" } },
    [
      _c("drm-auth"),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "ui_close",
          attrs: { href: "javascript:", type: "button", rel: "modal:close" },
          on: { click: _vm.onContinueClick }
        },
        [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
      ),
      _vm._v(" "),
      _c("dl", { staticClass: "modal_content" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap topLine" }, [
          _c("div", { staticClass: "btn_right pc_only" }, [
            _c(
              "a",
              {
                staticClass: "btn_blue",
                attrs: { href: "javascript:", title: "" },
                on: { click: _vm.onContinueClick }
              },
              [_vm._v("Continue")]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "ellipsis maintit" }, [
      _c("i", [_vm._v("Logged In Successfully!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal_txt" }, [
      _c(
        "div",
        {
          staticStyle: {
            height: "140px",
            "line-height": "70px",
            "text-align": "center"
          }
        },
        [
          _vm._v(
            "\n                Please click 'continue' to proceed!\n            "
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c2ca856", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c2ca856","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/certificate/CertLoginSuccessPopup.vue
// module id = cHTU
// module chunks = 0